const getBaseUrl = () => process.env.REACT_APP_API_URL;

const getPublicationBaseUrl = (urlEnding = '') => getBaseUrl() + '/publications/' + urlEnding;

const getUpgoingPublicationBaseUrl = (urlEnding = '') => getBaseUrl() + '/ongoing_publications/' + urlEnding;

const getMetaBaseUrl = (urlEnding = '') => getBaseUrl() + '/meta/' + urlEnding;

const getPerformanceBaseUrl = (urlEnding = '') => getBaseUrl() + '/performance/' + urlEnding;

const dateFormatter = new Intl.DateTimeFormat('en-US');
const formatDate = (date) => dateFormatter.format(date);

async function makeRequest(url, token = null, tenantId = null, method = 'GET', data = {}, contentType = 'application/json') {
    const options = {
        method
    };

    const headers = options.headers || {};

    if(method !== 'GET') {
        options.body = JSON.stringify(data);
        headers['Content-Type'] = contentType;
    }

    if(token) headers['Authorization'] = `Bearer ${token}`;

    if(tenantId) headers['Makrwatch-Tenant-Id'] = tenantId;

    if(Object.keys(headers).length > 0) {
        options.headers = headers;
    }

    const response = await fetch(url, options);
    const content = await response.json();
    return content;
}

export const publicationProxy =  {
    async getPublications({ pageSize, pageNumber, filterQueryString, searchText, sortField, sortDirection, metrics, aggregateMetrics}, token, tenantId, upcoming = false) {
        let url = upcoming ? getUpgoingPublicationBaseUrl() : getPublicationBaseUrl();
        url += `?page=${pageNumber}&per_page=${pageSize}`;

        if(filterQueryString) {
            url += '&' + filterQueryString;
        }

        if(searchText) {
            url += '&search_by=' + searchText;
        }

        if(sortField && sortDirection) {
            url += `&order_by=${sortField}&order_by_function=${sortDirection}`;
        }

        if(metrics && Array.isArray(metrics)) {
            url += '&metrics=' + metrics.join();
        }

        if(aggregateMetrics && Array.isArray(aggregateMetrics)) {
            url += '&totalling_metrics=' + aggregateMetrics.join();
        }

        return await makeRequest(url, token, tenantId);
    },

    exportPublications({ exportFields, filterQueryString, searchText, sortField, sortDirection, metrics }, token, tenantId) {
        let url = getPublicationBaseUrl('export');
        url += '?export_fields=' + exportFields.join();

        if(filterQueryString) {
            url += '&' + filterQueryString;
        }

        if(searchText) {
            url += '&search_by=' + searchText;
        }

        if(sortField && sortDirection) {
            url += `&order_by=${sortField}&order_by_function=${sortDirection}`;
        }

        if(metrics && Array.isArray(metrics)) {
            url += '&metrics=' + metrics.join();
        }

        makeRequest(url, token, tenantId, 'POST');
    },

    async getPublicationFilters(status_ids, token, tenantId) {
        let url = getPublicationBaseUrl('filters');

        if(status_ids && Array.isArray(status_ids)) {
            url += '?status=' + status_ids.join();
        }

        return await makeRequest(url, token, tenantId);
    },

    async getPublicationsBudget(BudgetType, budgetId, accessToken, tenantId) {
        let url = getPublicationBaseUrl('publicationBudget');

        const query = {filters: JSON.stringify({
                    "tenant_id": tenantId,
                    "budget_id": budgetId
                    }),
                    budget_type: BudgetType};

        url +=`?filters=${encodeURIComponent(query.filters)}&budget_type=${query.budget_type}`;

    return makeRequest(url, accessToken, tenantId);
    },

    async getDailyPublishedBudget(budgetId, accessToken) {
        let url = getPublicationBaseUrl(`publicationDailyBudget/${budgetId}`);

        return makeRequest(url, accessToken);
    },

    async getWeeklyAllocationBudgets(budgetId, accessToken) {
        let url = getPublicationBaseUrl(`weekly-allocation-budget/${budgetId}`);

        return makeRequest(url, accessToken);
    },

    async getBudgetForecast(budgetId, accessToken) {
        let url = getPublicationBaseUrl(`budget-forecast/${budgetId}`);

        return makeRequest(url, accessToken);
    },

    async getBudgetForecastSummary(budgetId, accessToken) {
        let url = getPublicationBaseUrl(`budget-forecast-total/${budgetId}`);

        return makeRequest(url, accessToken);
    }
};

export const metaProxy = {
    async getTenants(token) {
        let url = getMetaBaseUrl('tenants');
        return await makeRequest(url, token);
    }
};

export const performanceProxy =  {
    async getPerformanceMetrics({ startDate, endDate }, token, tenantId) {
        let url = getPerformanceBaseUrl('metrics');
        url += `?date=${formatDate(startDate)}-${formatDate(endDate)}`;

        return await makeRequest(url, token, tenantId);
    }
};
